<template v-if="allArticle">
    <div class="blog">
        <div class="blog-banner mb-6">
            <div class="text-center">
                <v-row>
                    <v-col class="justify-center align-center d-flex">
                        <h1>Blog Listings</h1>
                    </v-col>
                </v-row>
            </div>
        </div>
        <div class="content px-4">
            <div class="blog-content-wrap mb-10">
                <v-row>
                    <v-col cols="12 pb-0 pt-12">
                        <h4>Filter by Category</h4>
                    </v-col>
                    <v-col cols="12" md="3" class="pb-0 pt-2">
                        <v-select v-model="select" :items="AllCategories" item-value="value" item-text="title"
                            placeholder="All Categories" outlined dense class="btn-edu-height list-filter"
                            hide-details="auto" @change="categoryChangeHandler">
                            <template slot="append">
                                <span>
                                    <v-icon size="25">mdi-chevron-down</v-icon>
                                </span>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
                <v-row v-if="items">
                    <v-col class="mb-10 mt-2 card-wrap col-12">
                        <ItemCardPost v-for="post in items" :key="post.id" :post="post"></ItemCardPost>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <p class="content-empty">Nothing found</p>
                </v-row>
                <v-row>
                    <v-col cols="12" class="text-center mb-12 pb-12" v-if="pageCount > 1">
                        <paginate v-model="page" :page-count="pageCount" :click-handler="pageChangeHandler"
                            :prev-text="'<'" :next-text="`>`" :prev-class="'prev'" :next-class="'next'"
                            :container-class="'pagination'" :page-class="'waves-effect '">
                        </paginate>
                    </v-col>
                </v-row>
            </div>
        </div>
        <!-- <div class="blog-banner-footer mt-12">
            <div class="block-form-footer">               
                <v-row>
                    <v-col class="pb-0 pt-6">
                        <div class="klaviyo-form-VhKXTv"></div>
                    </v-col>
                </v-row>
            </div>
        </div> -->
    </div>
</template>

<script>
import ItemCardPost from "@/components/ItemCardPost.vue";
import paginationMixin from '@/mixins/pagination.mixin.js'
import { required, email } from 'vuelidate/lib/validators'
import SiteService from "../services/site.service";
import { flattenObj } from "@/utils/utils";


export default {
    validations: {
        name: { required },
        lastName: { required },
        email: { required, email },
    },
    components: { ItemCardPost },
    mixins: [paginationMixin],
    metaInfo() {
        return {
            meta: [
                { name: 'description', content: 'EDUrent\'s shared housing program provides the traditional college experience. Students share a space with classmates and make new friends on day one at move-in. Instead of a cramped, overpriced dorm room, you have the space and luxury of a full-size apartment home with a well-equipped kitchen. Our units are furnished with beds, dressers, and a couch and include utilities like electricity, and water, all at one low monthly cost. Each student in the program has an individual lease agreement and therefore is not responsible for roommates\' rent payments should a bed become vacant. Students in this program tend to carpool to school, study together, and share in this new life experience. Welcome to EDUrent!' },
            ]
        }
    },
    data () {
        return {
            allArticle: [],
            filterAllArticle: [],
            postCategory: [],
            lastName: '',
            name: '',
            email: '',
            select: '',
            isSendingMessage: false,
            defaultCategories: [
                {
                    id: 0,
                    value: '',
                    title: 'All Categories'
                }
            ],
        }
    },
    computed: {
        AllCategories() {            
            return this.defaultCategories.concat(this.postCategory);
        },
        nameErrors() {
            const errors = []
            if (!this.$v.name.$dirty) return errors
            !this.$v.name.required && errors.push('First Name is required.')
            return errors
        },
        lastNameErrors() {
            const errors = []
            if (!this.$v.name.$dirty) return errors
            !this.$v.name.required && errors.push('Last Name is required.')
            return errors
        },
        emailErrors() {
            const errors = []
            if (!this.$v.email.$dirty) return errors
            !this.$v.email.email && errors.push('Must be valid e-mail')
            !this.$v.email.required && errors.push('E-mail is required')
            return errors
        },
    },
    methods: {
        categoryChangeHandler() {
            this.allArticle = this.setupPagination(this.filterAllArticle.filter(article => {

                if (this.select) {
                
                    for (let i = 0; i < article.categories.length; i++) {
                        if (article.categories[i].title === this.select) {
                            
                            if (article.categories.length < this.pageSize || this.allItems[0]) {
                                this.$router.push(`${this.$route.path}`);
                            }

                            return article;
                        }

                    }
                } else {
                    return article;
                }
            })
            )
        },
        async  submit() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$store.commit('setSnackbar', {
                    show: true,
                    message: 'One or more mandatory fields are missing. Please look through the form and fix the field(s) highlighted in red',
                    color: 'red'
                });

                return
            }

            // send get info message
            this.$store.dispatch('sendJoinOurNewsletter', {
                name: this.name,
                lastName: this.lastName,
                email: this.email,
            }).then(() => {
                this.clear();
                this.$router.push(`/thank-you`);
            })
        },
        clear () {
            this.$v.$reset()

            this.name = ''
            this.lastName = ''
            this.email = ''
        },
    },
    async beforeMount()  {
        const response = await SiteService.getPosts();
        this.filterAllArticle = flattenObj(response);
   
        this.allArticle = flattenObj(response);
        this.allArticle.map(article => {
            for (let i = 0; i < article.categories.length; i++) {
                this.postCategory.push(article.categories[i]);
            }
        });   
        this.setupPagination(this.allArticle.map(article => {
            return article;
        }));
    },
    updated() {
        setTimeout(() => {
            document.querySelectorAll('.waves-effect').forEach((item, index) => {
                if (index < 10) {
                    item.classList.add('page-item-add');
                }

            });
        }, 100);
    }
}
</script>
<style>
.klaviyo-form .needsclick {
        padding-top: 0 !important;
    }
    .klaviyo-form h2 {
        margin-top: -10px !important;
    }
    .klaviyo-form p {
        padding-bottom: .8rem!important;
    }
    .klaviyo-form h2 span {
        font-size: 26px !important;
        font-weight: 700!important;
        color: #272629!important;
        font-family: Poppins!important;
        font-style: normal!important;
        line-height: 40px!important;
    }
    .btn-edu-height .v-input__slot .v-input__append-inner {
        margin-top: 5px!important;
        margin-bottom: 5px;
    }
    .blog-content-wrap .v-icon.v-icon {
        color: #000;
        line-height: 1.5;
    }
    .pagination .next a,
    .pagination .prev a {
        font-family: monospace;
        font-size: 20px;
    }
    .pagination .prev {padding-right: 15px;}
    .waves-effect.page-item-add {
        position: relative;
        z-index: 2;
    }
    .waves-effect.page-item-add:before {
        position: absolute;
        content: '0';
        top: 0;
        left: 2px;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 27px;
        -webkit-transition-duration: .4s;
        transition-duration: .4s;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        color: #727880;
        z-index: -1;
    }
    .waves-effect:hover:before,
    .waves-effect.active:before {
        color: #2D76E3;
    }
    .content-empty {
        padding: 50px 12px;
    }
    .blog {
        margin-top: 64px;
    }
    .blog .content {
        max-width: 1460px;
    }
    .pagination {
        display: flex;
        justify-content: center;
        list-style: none;
    }
    .list-filter {        
        border-radius: 9px;
        max-width: 304px;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        color: #272629;
    }
    .list-filter.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
        color: #272629;
        border: 2px solid #C3CBD6;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        /* or 150% */
    }
    .block-form-footer .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
        border-radius: 5px;
        border: 1px solid #9F9F9F;
    }
    .block-form-footer .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
        padding: 12px;
    }
    .list-filter .theme--light.v-label {
        color: #272629;
    }
    .pagination li a {
        color: #727880;
        padding: 15px;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 27px;
        transition-duration: .4s;
        /* identical to box height, or 169% */

        letter-spacing: 1.5px;
        text-transform: uppercase;
    }
    .pagination li a:hover,
    .pagination li.active a  {
        color: #2D76E3;
    }
    div.blog-banner {        
        padding-top: 140px;
        margin-top: -64px;
        display: block;
        min-height: 500px;
        background-image: url("../../src/assets/media/blog-banner.jpg");
        background-position: center center;
        background-size: cover;
        width: 100vw;
        height: auto;
        position: relative;       
    }
    div.blog-banner h1 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 48px;
        line-height: 72px;
        padding-top: 4%;
        /* identical to box height, or 150% */

        text-align: center;

        color: #FFFFFF;
    }
    div.blog-banner-footer {
        padding-top: 0;
        margin-top: 0;
        display: block;
        min-height: 420px;
        background-image: url("../../src/assets/media/blog-banner-footer.jpg");
        background-position: center center;
        background-size: cover;
        width: 100vw;
        height: auto;
        position: relative;
        display: flex;
        justify-content: center;
        align-content: center;
    }
    div.blog-banner-footer:before,
    div.blog-banner:before {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(39, 38, 41, 0.8);
        z-index: 1;
    }
    div.blog-banner h1 {
        color: #fff;
        z-index: 2;
    }
    .card-wrap {
        grid-gap: 50px;
        grid-template-columns: 1fr 1fr 1fr;
        display: grid;
    }
    .card-wrap:hover {
        cursor: pointer;
    }
    .card-post.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 15px;
        padding: 0;
        min-width: 0;
        justify-content: space-between;
        flex-direction: column;
        display: flex;
        transition-delay: .4s;
        overflow: hidden;

    }
    .card-post.v-card:not(.v-sheet--tile):not(.v-card--shaped):hover {
        box-shadow: 0px 8px 10px -5px rgb(0 0 0 / 20%), 0px 16px 24px 2px rgb(0 0 0 / 14%), 0px 6px 30px 5px rgb(0 0 0 / 12%);
    }
    .card-post .v-image {
        max-height: 307px;
    }
    .card-post  h2 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 26px;
        line-height: 40px;
    }
    .card-post .read-more span {
        color: #2850E9;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
        text-transform: capitalize;
        letter-spacing: normal;
    }
    .v-card__text {
        height: calc(100% - 56px);
    }
    .card-post .v-card__actions  {
        height: 56px;
    }
    .card-post .v-card__actions > .v-btn.v-btn.read-more  {
        padding: 0;
        height: auto;
    }
    .card-post.v-card:not(.v-sheet--tile):not(.v-card--shaped) .v-card__actions > .v-btn.v-btn.read-more span,
    .card-post.v-card:not(.v-sheet--tile):not(.v-card--shaped).read-more:active,
    .card-post.v-card:not(.v-sheet--tile):not(.v-card--shaped) .read-more:focus,
    .card-post.v-card:not(.v-sheet--tile):not(.v-card--shaped) .read-more:hover {
        background: #fff;
    }

    .card-text-wrap {
        justify-content: space-between;
        flex-direction: column;
    }
    .block-form-footer {
        background-color: #fff;
        max-width: 560px;        
        width: calc(100% - 32px);
        padding: 30px 40px 40px;
        margin: auto;
        z-index: 2;
        border-radius: 15px;
    }
    .block-form-footer  h2 {
        color: #272629;
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 700;
        font-size: 26px;
        line-height: 40px;
    }
    .block-form-footer .btn-edu-height label, .block-form-footer .btn-edu-select-height label {
        top: 6px !important;
    }
    .blog .v-select.v-text-field .v-select__slot .v-select__selections input::placeholder {
        color: #272629;
    }
    @media screen and (max-width: 1600px) {
        .card-wrap {
            grid-gap: clamp(30px, 1.3888888889vw, 50px);
        }
        .card-post h2 {
            line-height: 1.3;
        }
        div.blog-banner {
            min-height: 450px;
        }
    }
    @media screen and (max-width: 900px) {
        .card-wrap {
            grid-template-columns: 1fr 1fr;
        }
        .card-post .v-image {
            max-height: 200px;
        }
        div.blog-banner h1 {
            padding-top: 0;
        }
        div.blog-banner {
            min-height: 350px;
            padding-top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    @media screen and (max-width: 650px) {
        .card-wrap {
            grid-template-columns: 1fr;
        }
        .blog-content-wrap {
            max-width: 400px;
            margin: auto;
        }
        .list-filter {
            max-width: 100%;
        }
        div.blog-banner {
            min-height: 250px;
        }
        div.blog-banner h1 {
            font-size: 38px;
            line-height: 1.5;
            padding-bottom: 1rem;
        }
        div.blog-banner-footer{
            min-height: 500px;
        }
    }
     @media screen and (max-width: 378px) {
        .block-form-footer {
            margin-top: 20px;
            margin-bottom: 20px;
        }
    }
</style>
